<template>
  <div id="app">
    <TheTopNav/>    

    <div class="content-wrapper">
        <router-view/>
    </div>
        
    <TheFooter/>
    <TheLoader/>

    <ModalPlay/>
    <ModalRules/>

    <!-- Third Party Plugin -->
    <notifications group="app" position="top center" classes="app-notification"/>
  </div>
</template>

<script>
import TheTopNav from './components/layout/TheTopNav';
import TheFooter from './components/layout/TheFooter';
import TheLoader from './components/layout/TheLoader';
import TheBanner from "./components/layout/TheBanner";
import ModalRules from "./components/ModalRules";
import ModalPlay from "./components/ModalPlay";

export default {
  name: 'App',
  components: {
    TheFooter,
    TheLoader,
    TheTopNav,
    TheBanner,
    ModalPlay,
    ModalRules
  }
}
</script>

<style lang="less">
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css";
@import "https://use.fontawesome.com/releases/v5.0.8/css/all.css";
@import "assets/less/modal.less";
@import "assets/less/app.less";
</style>



// WEBPACK FOOTER //
// src/App.vue